/**
 * Section 3 color slider → variant sync for checkout.
 */
(function () {
  'use strict';

  function getPicker() {
    return document.querySelector('.product.js-product variant-picker');
  }

  function getProductData(picker) {
    if (!picker) return null;
    return picker.productData || picker.getProductData?.() || null;
  }

  function getSlideColors(sectionRoot) {
    const slider = sectionRoot.querySelector('convx-slider');
    const raw = slider?.dataset.slideColors;
    return raw ? raw.split('|').filter(Boolean) : [];
  }

  function getColorOptionIndex(picker) {
    let colorOptionIndex = -1;
    picker.querySelectorAll('.option-selector:not(.option-selector--custom)').forEach((selector, index) => {
      const name = selector.dataset.option;
      if (name === 'Color' || name === 'Colour') {
        colorOptionIndex = index;
      }
    });
    return colorOptionIndex;
  }

  function selectColorOption(colorValue) {
    const picker = getPicker();
    if (!picker || !colorValue) return false;

    const colorSelector = picker.querySelector('.option-selector[data-option="Color"]')
      || picker.querySelector('.option-selector[data-option="Colour"]');
    if (!colorSelector) return false;

    const input = colorSelector.querySelector(`input.js-option[value="${CSS.escape(colorValue)}"]`);
    if (!input) return false;
    if (input.checked) return true;

    input.click();
    return true;
  }

  function resolveVariantIdForColor(colorValue) {
    const picker = getPicker();
    const productData = getProductData(picker);
    if (!picker || !productData?.product || !colorValue) return null;

    const selectedOptions = picker.getSelectedOptions();
    const colorOptionIndex = getColorOptionIndex(picker);
    if (colorOptionIndex === -1) return null;

    const mergedOptions = selectedOptions.slice();
    mergedOptions[colorOptionIndex] = colorValue;

    const variant = productData.product.variants.find((v) =>
      v.options.every((val, index) => val === mergedOptions[index])
    );
    return variant?.id || null;
  }

  function setMainVariantInput(variantId) {
    if (!variantId) return;
    const mainInput = document.querySelector('.js-product-form-main input[name="id"]')
      || document.querySelector('.product.js-product .js-product-form input[name="id"]:not(.convx__section-3-checkout-form input)');
    if (mainInput) {
      mainInput.value = variantId;
      mainInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function applyColorToCheckoutForm(form, colorValue) {
    if (!colorValue) return false;

    const variantId = resolveVariantIdForColor(colorValue);
    const input = form.querySelector('input[name="id"]');
    if (!variantId || !input) return false;

    input.value = variantId;
    setMainVariantInput(variantId);
    selectColorOption(colorValue);
    return true;
  }

  function inferColorFromSlideCell(cell) {
    if (!cell) return null;
    if (cell.dataset.variantColor) return cell.dataset.variantColor;

    const src = cell.querySelector('img')?.currentSrc
      || cell.querySelector('img')?.src
      || '';
    if (!src) return null;

    const fileName = decodeURIComponent(src.split('/').pop()?.split('?')[0] || '');
    if (/\bwhite\b/i.test(fileName)) return 'White';
    if (/\bblack\b/i.test(fileName)) return 'Black';
    return null;
  }

  function getActiveSlideColor(sectionRoot) {
    const slider = sectionRoot.querySelector('convx-slider');
    if (!slider || typeof Flickity === 'undefined') return null;

    const flkty = Flickity.data(slider);
    if (!flkty) return null;

    const cells = slider.querySelectorAll('.convx__slider-cell');
    const cell = cells[flkty.selectedIndex];
    const fromCell = inferColorFromSlideCell(cell);
    if (fromCell) return fromCell;

    const colors = getSlideColors(sectionRoot);
    return colors[flkty.selectedIndex] || null;
  }

  function bindFlickityChange(sectionRoot, form) {
    const slider = sectionRoot.querySelector('convx-slider');
    if (!slider) return;

    const tryBind = () => {
      if (typeof Flickity === 'undefined') {
        requestAnimationFrame(tryBind);
        return;
      }

      const flkty = Flickity.data(slider);
      if (!flkty) {
        requestAnimationFrame(tryBind);
        return;
      }

      flkty.on('change', (index) => {
        const cells = slider.querySelectorAll('.convx__slider-cell');
        const color = inferColorFromSlideCell(cells[index]) || getSlideColors(sectionRoot)[index];
        if (color) applyColorToCheckoutForm(form, color);
      });
    };

    tryBind();
  }

  function initSection3(sectionRoot) {
    const form = sectionRoot.querySelector('.convx__section-3-checkout-form');
    if (!form || form.dataset.section3Init) return;
    form.dataset.section3Init = 'true';

    bindFlickityChange(sectionRoot, form);

    form.addEventListener('submit', (event) => {
      if (form.dataset.section3Submitting === 'true') return;

      const color = getActiveSlideColor(sectionRoot);
      if (!color) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!applyColorToCheckoutForm(form, color)) return;

      form.dataset.section3Submitting = 'true';
      form.submit();
    }, { capture: true });
  }

  function init() {
    document.querySelectorAll('.convx__section-3-checkout-form').forEach((form) => {
      const sectionRoot = form.closest('.shopify-section');
      if (sectionRoot) initSection3(sectionRoot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
